import React from "react";
import glamorous, { Div } from "glamorous";

const LoadMoreContainer = glamorous.div({
  paddingTop: 32,
  textAlign: "center"
});
const Icon = glamorous.div({
  display: "inline-block",
  ":hover": {
    cursor: "pointer"
  }
});

const Text = glamorous.p({
  margin: "0 0 0 2px"
});

const loadMore = (
  <svg
    width="33"
    height="24"
    viewBox="0 0 33 24"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="linearGradient-1">
        <stop stopColor="#9E9C9D" offset="0%" />
        <stop stopColor="#D7D7D7" offset="48.377%" />
        <stop stopColor="#A7A5A6" offset="100%" />
      </linearGradient>
      <path
        d="M16.3345216,0 L24.5026792,11.9509078 L32.6690432,23.900022 C32.6690432,23.900022 20.70558,15.7623559 16.3345216,15.7623559 C11.9634632,15.7623559 0,23.900022 0,23.900022 L8.16636398,11.9509078 L16.3345216,0 Z"
        id="path-2"
      />
    </defs>
    <g id="Symbols" fill="none" fillRule="evenodd">
      <g id="Load-More" transform="translate(-21 -27)">
        <g transform="translate(21 27)" id="ico-navigator">
          <mask id="mask-3" fill="#fff">
            <use xlinkHref="#path-2" />
          </mask>
          <use
            id="navigator"
            fill="url(#linearGradient-1)"
            transform="matrix(1 0 0 -1 0 23.9)"
            xlinkHref="#path-2"
          />
        </g>
      </g>
    </g>
  </svg>
);

const LoadMore = props => {
  return (
    <LoadMoreContainer
      {...props}
      onClick={() =>
        props.dropInSearchResults(props.searchUsers, props.filters)
      }
    >
      <Icon>
        <Text>Load More</Text>
        {loadMore}
      </Icon>
    </LoadMoreContainer>
  );
};

export default LoadMore;



// WEBPACK FOOTER //
// ./src/components/common/LoadMore.jsx